import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.get("/api/measures", { params });
};

const getWritableMeasure = (params) => {
  return restApi.get("/api/measures/writable", { params });
};

const getWritableByUser = (params) => {
  return restApi.get("/api/measures/writable/user", { params });
}

const getChannelMeasure = (params) => {
  return restApi.get("/api/measures/channel", { params });
};

// DP 설정(Measure Display Name) 화면 - MeasureType.getDisplayNameList() 코드 목록
const getDisplayNameList = () => {
  return restApi.get("/api/measures/display-name-list");
};

const upsert = data => {
  return restApi.post("/api/measures", data);
};

const upsertChannel = data => {
  return restApi.post("/api/measures/channel", data);
};

const basicUpsert = data => {
  return restApi.post("/api/basic-measures", data);
};

const remove = ids => {
  return restApi.delete(`/api/measures/${ids}`);
};

const measureService = {
  getAll,
  getWritableByUser,
  getWritableMeasure,
  getChannelMeasure,
  getDisplayNameList,
  upsert,
  upsertChannel,
  basicUpsert,
  remove
};



export default measureService;